// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-81fb6bf4]{width:100%;margin:0 auto;padding:0}.socialmedia[data-v-81fb6bf4]{display:flex;gap:1rem;align-items:center;justify-content:space-between}.socialmedia-left[data-v-81fb6bf4]{margin-left:3rem;font-size:.8rem}.socialmedia-right[data-v-81fb6bf4]{display:flex;gap:1.5rem}", ""]);
// Exports
module.exports = exports;
